class FeaturedSwiperSlider extends HTMLElement {
  constructor() {
    super();

    window.addEventListener('DOMContentLoaded', this._setupSlider);

    if (Shopify.designMode) {
      document.addEventListener("shopify:block:select", this._setupSlider);
      document.addEventListener("shopify:block:deselect", this._setupSlider);
      document.addEventListener("shopify:section:select", this._setupSlider);
      document.addEventListener("shopify:section:deselect", this._setupSlider);
    }

  }

  _setupSlider() {
    const swiperEl = document.querySelector('swiper-container');
    this.swiper = swiperEl;

    const swiperParams = {
      on: {
        init() {
          swiperEl.classList.add("slider-ready")
        }
      }
    }

    Object.assign(swiperEl, swiperParams);

    swiperEl.initialize();
  }

}

customElements.define('featured-slider', FeaturedSwiperSlider);
